import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { DayPicker } from "react-day-picker";
import { fr } from "date-fns/locale";
import { format, parse, isValid } from "date-fns";
import React, { useState } from "react";
import "react-day-picker/dist/style.css";
import "./index.css";

export function Component({
  value,
  captionLayout = "dropdown-years",
  fromYear = 1950,
  toYear = 2040,
  onChange,
}) {
  const now = new Date();
  // Try to parse various date formats
  let parsedDate = parse(value, "dd.MM.yyyy", new Date());
  if (!isValid(parsedDate)) {
    parsedDate = parse(value, "yyyy-MM-dd", new Date());
  }
  if (!isValid(parsedDate)) {
    parsedDate = new Date(value);
  }
  const validDate = isValid(parsedDate);
  const defaultDate = validDate ? parsedDate : now;
  const [date, setDate] = useState(defaultDate);

  const handleDaySelect = (date, _, __, e) => {
    e.preventDefault();
    e.stopPropagation();
    setDate(date);
    onChange(format(date, "dd.MM.yyyy"), format(date, "yyyy-MM-dd"));
  };

  return (
    <DayPicker
      locale={fr}
      mode="single"
      defaultMonth={defaultDate}
      selected={date}
      onSelect={handleDaySelect}
      captionLayout={captionLayout}
      fromYear={fromYear}
      toYear={toYear}
    />
  );
}

export default class extends Controller {
  static targets = ["input", "dropdownContent", "hidden"];

  connect() {
    const { inputTarget, dropdownContentTarget, hiddenTarget } = this;
    this.root = createRoot(this.dropdownContentTarget);
    this.root.render(
      <Component
        value={dropdownContentTarget.dataset.value}
        onChange={(displayValue, databaseValue) => {
          inputTarget.innerText = displayValue;
          hiddenTarget.value = databaseValue;
          document.querySelector("body").click();
        }}
      />,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
